import ls from 'local-storage';

if (window && window.sessionStorage) {
  ls.backend(window.sessionStorage);
}

export default ls;
